<template>
  <div class="flex flex-col items-center py-8 px-4">
    <div class="w-full max-w-lg">
      <div class="mb-6">
        <h2 class="text-base font-semibold text-gray-800">Send System Message</h2>
        <p class="text-sm text-gray-500 mt-1">Broadcast a message to all users of a selected account type. Use this to
          notify applicants, partners or backoffice staff of system updates or maintenance.</p>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl shadow-sm p-6">
        <form @submit.prevent="send" class="space-y-4">
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Message</label>
            <textarea
              v-model="form.messageToSend"
              placeholder="What do you want to say?"
              rows="6"
              class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
            ></textarea>
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Recipients</label>
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-6 md:col-span-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    v-model="form.recipientList"
                    value="INDIVIDUAL"
                    class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary"
                  />
                  <span class="text-sm text-gray-700">User Accounts</span>
                </label>
              </div>
              <div class="col-span-6 md:col-span-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    v-model="form.recipientList"
                    value="BUSINESS"
                    class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary"
                  />
                  <span class="text-sm text-gray-700">Business Accounts</span>
                </label>
              </div>
              <div class="col-span-6 md:col-span-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    v-model="form.recipientList"
                    value="BACKOFFICE"
                    class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary"
                  />
                  <span class="text-sm text-gray-700">Staff Accounts</span>
                </label>
              </div>
              <div class="col-span-6 md:col-span-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    v-model="form.recipientList"
                    value="MDA"
                    class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary"
                  />
                  <span class="text-sm text-gray-700">MDA Accounts</span>
                </label>
              </div>
              <div class="col-span-6 md:col-span-4">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    v-model="form.recipientList"
                    value="PARTNER"
                    class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary"
                  />
                  <span class="text-sm text-gray-700">Partner Accounts</span>
                </label>
              </div>
            </div>
          </div>

          <div class="border-t border-gray-100 pt-2 flex justify-end">
            <button
              type="submit"
              :disabled="loading"
              class="btn-primary"
            >
              <i class="fa-solid fa-paper-plane"></i>
              <span>Send Message</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useConfigurationsStore } from "../../../stores";

interface MessageForm {
  messageToSend: string | null;
  recipientList: string[];
  senderUserId: string | null;
}

const store = useConfigurationsStore();
const loading = ref(false);
const form = ref<MessageForm>({
  messageToSend: null,
  recipientList: [],
  senderUserId: null
});

const send = () => {
  if (!form.value.messageToSend || form.value.recipientList.length === 0) {
    return;
  }

  loading.value = true;
  const currentUser = JSON.parse(sessionStorage.getItem("current_user") || "{}");
  form.value.senderUserId = currentUser.userId;
  store.sendMessage(form.value);
};

const resetForm = () => {
  form.value = {
    messageToSend: null,
    recipientList: [],
    senderUserId: null
  };
};

watch(
  () => store.messageSentSuccess,
  (success) => {
    if (success) {
      loading.value = false;
      // @ts-ignore - successToast is injected globally
      window.successToast("Success", "Message sent");
      resetForm();
    }
  }
);
</script>

